var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(!_vm.netError)?_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]}):_c('net-fail',{attrs:{"reload-function":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }